// apiHelper.js
import axios_native from 'axios';

class ApiHelper {
  constructor(apiEndpoint, requestType = 'POST', postData = null) {
    this.apiEndpoint = apiEndpoint;
    this.requestType = requestType.toUpperCase();
    this.postData = postData;
  }

  async fetchData() {
    try {
      const config = {
        url: this.apiEndpoint,
        method: this.requestType,
        data: this.postData,
      };

      if (this.requestType === 'GET' || this.requestType === 'DELETE') {
        delete config.data;
      }

      const response = await axios_native(config);
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }
}

export default ApiHelper;
